module.exports = __webpack_public_path__ + "assets/img/next-episode.c501e6e9.svg";